var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.71 14.21-1.42-1.42 5.3-5.29-5.3-5.29L5.71.79l6.7 6.71-6.7 6.71z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationNext);
export default __webpack_public_path__ + "static/media/PaginationNext.d15c7c3bedd978beaff7ee8ad4473e21.svg";
export { ForwardRef as ReactComponent };